import { Flex, Accordion, Text } from '@mantine/core';
import classes from './OnboardingChecklist.module.css';
import { observer } from 'mobx-react';
import { PropsWithChildren } from 'react';
import { CheckListCheckBox } from '../../../../component';

export const BaseItem = observer(
  ({
    index,
    item,
    title,
    handleTick,
    changeableWhenDone = true,
    showChevron = true,
    deactivated = false,
  }: {
    index: number;
    item: {
      done: boolean;
    };
    title: string;
    handleTick: () => void;
    changeableWhenDone?: boolean;
    showChevron?: boolean;
    deactivated?: boolean;
  } & PropsWithChildren) => {
    const accordionProps = {
      styles: {
        chevron: { display: showChevron ? 'block' : 'none' },
      },
    };

    return (
      <Flex gap="10px" align="center">
        <CheckListCheckBox
          done={item.done}
          deactivated={deactivated}
          index={index}
          onClick={handleTick}
        />
        <Accordion.Control
          {...accordionProps}
          key="accordion-control"
          className={classes.accordion}
          disabled={deactivated}
        >
          <Text lh="20px">{title}</Text>
        </Accordion.Control>
      </Flex>
    );
  },
);
